import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as Sentry from '@sentry/react';

// Inicializar Sentry en el cliente
Sentry.init({
  dsn: "https://7dad0143010654fb9bafbae6c20c7573@o4509294908801024.ingest.us.sentry.io/4509311927517184",
  tracesSampleRate: 1.0,
  environment: process.env.NODE_ENV,
  sendDefaultPii: true
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
